class ZoomImageManager {
  zoomValue: number;
  zoomRangeStep: number;
  zoomMinValue: number;
  zoomMaxValue: number;
  _onChangeCustom?: (newZoomLevel: number) => void;
  _onChangeReact?: (newZoomLevel: number) => void;
  zoomRangeLine: number;

  constructor() {
    this.zoomValue = 1;
    this.zoomRangeStep = 0.5;
    this.zoomMinValue = 1;
    this.zoomMaxValue = 4;
    this.zoomRangeLine = 0;
    this._onChangeCustom = undefined;
  }

  setOnChange = (onZoomFunc: any) => {
    this._onChangeCustom = onZoomFunc;
  };

  setOnChangeReact = (onZoomFunc: (newZoom: number) => void) => {
    this._onChangeReact = onZoomFunc;
  };

  update = (value: number) => {
    this.zoomValue = value;
    this.zoomRangeLine = value;
    if (this._onChangeReact) {
      this._onChangeReact(value);
    }
  };

  setZoomValue = (value: number) => {
    this.zoomValue = value;
    if (this._onChangeCustom) {
      this._onChangeCustom(value);
    }
    if (this._onChangeReact) {
      this._onChangeReact(value);
    }
  };
}

export default ZoomImageManager;
